import type { Table } from "@tanstack/react-table";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { GenericTableFacetedFilter } from "../shared/GenericTableFacetedFilter";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

type SelectSpecValuesTableToolbarProps<TData> = {
  conditions: string[];
  deviceClasses: string[];
  onShowMasterSpecsChange?: (show: boolean) => void;
  showMasterSpecs?: boolean;
  showMasterSpecsToggle: boolean;
  table: Table<TData>;
};
export function SelectSpecValuesTableToolbar<TData>({
  conditions,
  deviceClasses,
  onShowMasterSpecsChange,
  showMasterSpecs,
  showMasterSpecsToggle,
  table,
}: SelectSpecValuesTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;
  const isGlobalFilterActive = table.getState().globalFilter?.length > 0;

  const deviceClassOptions = deviceClasses.map((o) => ({
    label: o,
    value: o,
  }));

  const conditionOptions = conditions.map((o) => ({
    label: o,
    value: o,
  }));

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center gap-2">
        <div className="relative flex items-center rounded-md border focus-within:ring-1 focus-within:ring-ring pl-2">
          <Search className="h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search by Spec, Report, Legacy or DUT name"
            value={table.getState().globalFilter ?? ""}
            onChange={(event) => table.setGlobalFilter(event.target.value)}
            className="h-8 w-[150px] lg:w-[350px] border-0 focus-visible:ring-0 shadow-none"
          />
        </div>
        {table.getColumn("deviceClass") ? (
          <GenericTableFacetedFilter
            column={table.getColumn("deviceClass")}
            title="Device Class"
            options={deviceClassOptions}
          />
        ) : null}
        {table.getColumn("condition") ? (
          <GenericTableFacetedFilter
            column={table.getColumn("condition")}
            title="Condition"
            options={conditionOptions}
          />
        ) : null}
        {isFiltered || isGlobalFilterActive ? (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              table.resetColumnFilters();
              table.resetGlobalFilter();
            }}
          >
            Clear filters
            <X />
          </Button>
        ) : null}
      </div>
      {showMasterSpecsToggle ? (
        <div className="flex items-center gap-2">
          <Switch
            id="show-master-specs"
            checked={showMasterSpecs}
            onCheckedChange={onShowMasterSpecsChange}
          />
          <Label htmlFor="show-master-specs" className="cursor-pointer">
            Show master specs
          </Label>
        </div>
      ) : null}
    </div>
  );
}
